export function validPrice(field) {
    const price = /^[0-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;
    return price.test(field.value) ? true : false;
}
